import uuid from "../../../library/uuid.js";
import global from "../../global.js";
import ObjectHandle from "../ObjectHandle.js";
const d3 = global.d3;

// const log = global.log.getLogger("f_mtac.scene.drivers.arrowline");
//log.setLevel(log.levels.DEBUG);

import {simplify} from "svg-utils";
import {format_distance} from "./Utils.js";
const ArrowLine = function (group, color) {
    this.data = {
        id: `local-${uuid()}`,
        segments_number: 0,
        segments: [[]],
        color: color,
        class: ["node", "line", "object", "movable", "removable"],
        storage: "object"
    };
    this.scene = global.scene; // Common style.rule_set
    this.group = group;
    this.handle = null;
    this.node = null;
    this.arrow_group = null;
    this.arrow_line = null;
    this.arrow_head = null;
    this.timer = null;
    this.position = null;
    this.initial_position = null;
};
ArrowLine.prototype.render_driver = d3
    .line()
    .x((d) => d.x)
    .y((d) => d.y);
ArrowLine.prototype.render = function () {
    const data = this.data.segments.reduce((s1, s2) => s1.concat(s2));
    return this.render_driver(simplify(data, 3 / global.scene.root_transform.k, true));
};
ArrowLine.prototype.draw = function (x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g").attr("class", this.data.class.join(" "));
    this.arrow_group = this.node.append("g");
    this.data.segments[0].push({x, y});
    this.position = {x, y};
    this.arrow_line = this.node.append("path").attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-dasharray", "10, 5").attr("d", this.render());
    this.arrow_head = this.arrow_group.append("polygon").attr("class", "arrow_head").attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 1).attr("fill", this.data.color).attr("fill-opacity", 1);

    let object_handle = ObjectHandle({x, y, color: this.data.color});
    // distance is refering to real distance between the two last points
    this.distance_group = this.node.append("g").attr("class", "distance_group");
    this.distance = this.distance_group.append("g").attr("class", "distance");
    this.distance_text_group = this.distance.append("g").attr("id", "distance_overlay");
    this.distance_frame = this.distance_text_group
        .append("rect")
        .attr("rx", global.app.scale.wb / 4)
        .attr("opacity", "50%")
        .attr("fill", this.data.color);
    this.distance_text = this.distance_text_group.append("text").attr("id", "distance_text");
    this.node.append(() => object_handle.node());
    this.initial_position = {x, y};
    if (global.storage.selected_context.projection.project == null) {
        //grid scale not visible if sitac is not georeferenced
        this.scene.style.rule_set(
            "distance_group_visibility",
            `
            #${this.data.id} g.distance_group {visibility: hidden;}
        `
        );
    } else {
        this.scene.style.rule_set(
            "distance_group_visibility",
            `
        #${this.data.id} g.distance_group {visibility: visible;}
    `
        );
    }
};

const get_angle = (dx, dy) => {
    var angle;
    if (dx === 0) {
        if (dy < 0) {
            angle = -Math.PI / 2;
        } else {
            angle = Math.PI / 2;
        }
    } else if (dx > 0) {
        angle = Math.atan(dy / dx);
    } else if (dx < 0) {
        angle = Math.atan(dy / dx) - Math.PI;
    }
    angle = (angle / (2 * Math.PI)) * 360;
    return angle;
};

ArrowLine.prototype.update = function (x, y) {
    // calculate angle according to segment origin
    this.position = {x, y};
    let N = this.data.segments_number;
    let dx = x - this.data.segments[N][0].x;
    let dy = y - this.data.segments[N][0].y;
    // check size of segment
    if (Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) < 5 / global.scene.root_transform.k) {
        return;
    }

    // add segment
    const a = 60,
        b = 30,
        sa = 40,
        sb = 20,
        sw = 3;
    let angle = get_angle(dx, dy);

    // update coordinates of end of current segment
    this.data.segments[N][1] = {x, y};

    this.arrow_line.attr("d", this.render());

    let arrow_head_points = [
        [x, y],
        [x - a, y - b],
        [x - a, y + b]
    ]
        .map((p) => p.join(","))
        .join(" ");

    this.arrow_head.attr("stroke", this.data.color).attr("stroke-width", sw).attr("stroke-opacity", 1).attr("fill", this.data.color).attr("fill-opacity", 1).attr("points", arrow_head_points).attr("transform-origin", `${x}px ${y}px`);

    this.arrow_group.attr("transform", `rotate(${angle})`).attr("transform-origin", `${x}px ${y}px`);

    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
        let N = this.data.segments_number;
        dx = x - this.initial_position.x;
        dy = y - this.initial_position.y;
        angle = get_angle(dx, dy);
        this.arrow_group.attr("transform", `rotate(${angle})`);

        //calcul milieu segment N et ajout fleche
        let dxs = this.data.segments[N][1].x - this.data.segments[N][0].x;
        let dys = this.data.segments[N][1].y - this.data.segments[N][0].y;
        let mid_segment = {x: this.data.segments[N][0].x + dxs / 2, y: this.data.segments[N][0].y + dys / 2};
        let segment_angle = get_angle(dxs, dys);
        let arrow_segment_group = this.node.append("g");
        arrow_segment_group.attr("transform", `rotate(${segment_angle})`).attr("transform-origin", `${mid_segment.x}px ${mid_segment.y}px`);
        let arrow_segment_points = [
            [mid_segment.x, mid_segment.y],
            [mid_segment.x - sa, mid_segment.y - sb],
            [mid_segment.x - sa, mid_segment.y + sb]
        ]
            .map((p) => p.join(","))
            .join(" ");
        arrow_segment_group
            .append("polygon")
            .attr("class", "arrow_segment")
            .attr("stroke", this.data.color)
            .attr("stroke-width", 3)
            .attr("stroke-opacity", 0.4)
            .attr("fill", this.data.color)
            .attr("fill-opacity", 0.2)
            .attr("points", arrow_segment_points)
            .attr("transform-origin", `${mid_segment.x}px ${mid_segment.y}px`);

        this.data.segments.push([this.data.segments[N][1]]);
        this.initial_position = {x: this.data.segments[N][1].x, y: this.data.segments[N][1].y};
        this.data.segments_number = N + 1;
        this.arrow_line.attr("stroke", this.data.color).attr("stroke-width", 3).attr("fill", "none").attr("d", this.render());
        this.arrow_head.attr("stroke", this.data.color).attr("stroke-width", sw).attr("stroke-opacity", 1).attr("fill", this.data.color).attr("fill-opacity", 1).attr("points", arrow_head_points).attr("transform-origin", `${x}px ${y}px`);
        this.distance = this.distance_group.append("g").attr("class", "distance");
        this.distance_text_group = this.distance.append("g").attr("id", "distance_overlay");
        this.distance_frame = this.distance_text_group
            .append("rect")
            .attr("rx", global.app.scale.wb / 4)
            .attr("opacity", "50%")
            .attr("fill", this.data.color);
        this.distance_text = this.distance_text_group.append("text").attr("id", "distance_text");
    }, 500);

    // Compute the real world radius distance
    let computed_distance = global.view.get_distance_meter( 
        [this.initial_position.x, this.initial_position.y],
        [this.position.x, this.position.y]
    );

    if (computed_distance !== undefined) { // i.e. if a projection is defined for the view
        this.distance_text.text(format_distance(computed_distance));
    }

    // Calculate the middle to place the distance on it
    let middle_radius = {};
    middle_radius.x = (this.position.x + this.initial_position.x) / 2;
    middle_radius.y = (this.position.y + this.initial_position.y) / 2;
    // Fetch the dimension of the box to prepare the frame
    var {width: w, height: h, x1, y1} = this.distance_text.node().getBBox();
    // Move the text and frame a little bit to center it on the line
    x1 = middle_radius.x - w / 2;
    y1 = middle_radius.y + h / 3; // the division here work fine (tested to find this value)
    this.distance_text.attr("x", x1).attr("y", y1);
    // Padding
    h += 6;
    w += 18;
    x1 = middle_radius.x - w / 2;
    y1 = middle_radius.y - h / 2;
    this.distance_frame.attr("x", x1).attr("y", y1).attr("width", w).attr("height", h);
    // Transform-origin is necessary here for the scale on zoom and dezoom
    this.distance.attr("transform-origin", `${middle_radius.x}px ${middle_radius.y}px`);

    this.distance.attr("transform-box", "fill-box");
};
ArrowLine.prototype.end = function () {
    if (this.timer !== null) {
        window.clearTimeout(this.timer);
        this.timer = null;
    }
    this.scene.style.rule_set(
        "distance_group_visibility",
        `
        #${this.data.id} g.distance_group {visibility: hidden;}
    `
    );
    return Promise.resolve();
};
ArrowLine.prototype.is_empty = function () {
    let N = this.data.segments_number;
    return this.data.segments[N].length === 0;
};
ArrowLine.prototype.detach = function () {
    this.handle = null;
    this.node = null;
    this.arrow_group = null;
    this.arrow_line = null;
    this.arrow_head = null;
};
ArrowLine.prototype.export = function () {
    return this.handle;
};
export default ArrowLine;
